module.exports = __webpack_public_path__ + "static/gallery-banner-1c50976e6676106e1655b2b42520c84c.png";